import { processingStateTypes } from "./constants";

export const getStateByID = (stateID) =>
  processingStateTypes.find((item) => item.id === stateID);
